/**
 * Feature Flag Definitions
 *
 * Central registry of all feature flags. Each flag has a unique string key
 * that matches the key configured in PostHog (or overridden locally).
 *
 * Flags default to `false` (off) so the app works safely without PostHog.
 */

export const FEATURE_FLAGS = {
  VIZIJ_FACES: "vizij_faces",
  FLOW_VIEW: "flow_view",
} as const;

export type FeatureFlagKey = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];

/** Safe defaults — used when PostHog hasn't loaded or the flag is unknown. */
export const FEATURE_FLAG_DEFAULTS: Record<FeatureFlagKey, boolean> = {
  vizij_faces: false,
  flow_view: false,
};

/** Human-readable metadata for each flag — used by the settings UI. */
export type FeatureFlagMeta = {
  key: FeatureFlagKey;
  label: string;
  description: string;
};

export const FEATURE_FLAG_META: FeatureFlagMeta[] = [
  {
    key: FEATURE_FLAGS.VIZIJ_FACES,
    label: "Expressive Faces Powered by Vizij",
    description:
      "Enable expressive 3D face rendering powered by Vizij, including lip-sync and animated emotions.",
  },
  {
    key: FEATURE_FLAGS.FLOW_VIEW,
    label: "Flow View",
    description:
      "Enable a node-based Flow view for templates, allowing you to visualize and edit button hierarchies as a graph.",
  },
];
